import { inject, Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class Notifications {
  private defaultConfig: MatSnackBarConfig = {
    horizontalPosition: 'center',
    verticalPosition: 'bottom',
  };

  private readonly snackBar = inject(MatSnackBar);

  constructor() {}

  showSuccess(
    message: string,
    action: string = 'Cerrar',
    customConfig?: Partial<MatSnackBarConfig>,
  ): void {
    this.snackBar.open(message, action, {
      ...this.defaultConfig,
      panelClass: ['success-snackbar'],
      ...customConfig,
    });
  }

  showError(
    message: string,
    action: string = 'Cerrar',
    customConfig?: Partial<MatSnackBarConfig>,
  ): void {
    this.snackBar.open(message, action, {
      ...this.defaultConfig,
      panelClass: ['error-snackbar'],
      ...customConfig,
    });
  }

  showInfo(
    message: string,
    action: string = 'Cerrar',
    customConfig?: Partial<MatSnackBarConfig>,
  ): void {
    this.snackBar.open(message, action, {
      ...this.defaultConfig,
      panelClass: ['info-snackbar'],
      ...customConfig,
    });
  }
}
